import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'

import { getScheduleName } from './helpers'

export const useActiveSchedule = ({ formPath }) => {
  const [{ value: { activeAvailabilityRuleId, usingCustomHours, ownerAvailabilityRules } }] = useFormField({ name: formPath })
  const primaryRuleId = ownerAvailabilityRules?.primaryRuleId
  const memberSchedules = ownerAvailabilityRules?.rules


  const activeSchedule = (!usingCustomHours && memberSchedules) ? memberSchedules.find(({ id }) => id === activeAvailabilityRuleId) : null

  const activeScheduleName = usingCustomHours
    ? I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.custom_label')
    : getScheduleName(activeSchedule.id === primaryRuleId, activeSchedule.name)

  return { activeSchedule, activeScheduleName }
}
